/**
 * Module to handle adding and removing of visibilitychange listeners for detecting when the
 * documents visibility state has become "hidden".
 * @param  {Function} options.callback - The function to call when the document becomes hidden.
 * @return {Function} obj.removeListener - Removes the `visibilitychange` and `pagehide` listeners
 * added to the document.
 */
var onDocumentHidden = function onDocumentHidden(_ref) {
  var callback = _ref.callback;

  var listener = function listener(event) {
    if (event.type === 'visibilitychange') {
      if (document.visibilityState === 'hidden') {
        callback();
        document.removeEventListener('visibilitychange', listener);
        document.removeEventListener('pagehide', listener);
      }
    } else {
      // The pagehide event (Safari support)
      callback();
      document.removeEventListener('visibilitychange', listener);
      document.removeEventListener('pagehide', listener);
    }
  };

  var removeListener = function removeListener() {
    if (typeof callback === 'function') {
      document.removeEventListener('visibilitychange', listener);
      document.removeEventListener('pagehide', listener);
    }
  };

  if (typeof callback === 'function') {
    document.addEventListener('visibilitychange', listener);
    /**
     * Safari doesn't fire the visibilitychange event when navigating away from a document, so also
     * add a listener for the `pagehide` event.
     */

    document.addEventListener('pagehide', listener);
  }

  return {
    removeListener: removeListener
  };
};

export { onDocumentHidden };
